// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions-container[data-v-224bb738],.description-container[data-v-224bb738],.name-container[data-v-224bb738]{padding:1rem}.name-container[data-v-224bb738]{font-size:1.25rem;font-weight:600}.description-container[data-v-224bb738]{border-top:.0625rem solid #2d353a;border-bottom:.0625rem solid #2d353a;font-size:1rem;line-height:1.25rem}", ""]);
// Exports
module.exports = exports;
